import {Base} from "@/api/Base"

export class LogEdit extends Base {
    path = "log/edit"
}